module.exports = __webpack_public_path__ + "img/candela-hello-world-dark.6e84f835.jpg";